var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSdrs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0875 18.8878L11.0828 18.8851L13.225 15.1378H16.25C17.6313 15.1378 18.75 14.019 18.75 12.6378V5.13779C18.75 3.75654 17.6313 2.63779 16.25 2.63779H3.75C2.36875 2.63779 1.25 3.75654 1.25 5.13779V12.6378C1.25 14.019 2.36875 15.1378 3.75 15.1378H9.375V13.8878H3.75C3.05625 13.8878 2.5 13.3315 2.5 12.6378V5.13779C2.5 4.44404 3.05625 3.88779 3.75 3.88779H16.25C16.9438 3.88779 17.5 4.44404 17.5 5.13779V12.6378C17.5 13.3315 16.9438 13.8878 16.25 13.8878H12.5L10 18.2628L11.0828 18.8851L11.0812 18.8878H11.0875ZM15 6.38779H5V7.63779H15V6.38779ZM5 10.1378H11.25V11.3878H5V10.1378Z",
    fill: "url(#paint0_linear_109_651)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_651",
    x1: 1.66667,
    y1: 2.52294,
    x2: 19.1667,
    y2: 19.1896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.137787)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdrs);
export default __webpack_public_path__ + "static/media/sdrs.12fca394f73095299154ee70bf1d4ff0.svg";
export { ForwardRef as ReactComponent };